var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldPaintbucket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.59 3.951c-3.16-3.15-4.82-1.99-6.82 0l-5.66 5.66c-1.15 1.15-1.78 1.89-2.01 2.71 0 .007-.003.01-.01.01v.05c-.41 1.46.67 2.7 2.02 4.05l3.53 3.51c1.26 1.27 2.28 2.06 3.41 2.06 1.13 0 2.1-.76 3.4-2.06l5.66-5.65c.49-.5.85-.91 1.13-1.3v-.01h.01c1.28-1.79.94-3.44-1.14-5.51l-3.52-3.52zm2.48 7.42c-.3-.07-.61-.13-.92-.19-.02 0-.04-.01-.07-.01-.7-.13-1.41-.24-2.13-.33h-.04c-.72-.09-1.45-.16-2.18-.2h-.08c-.64-.04-1.29-.06-1.93-.06a36.005 36.005 0 0 0-2.7.12c-.58.04-1.16.1-1.73.17l-.46.06c-.58.09-1.15.18-1.72.29-.13.03-.25.05-.38.07l-.16.03c.18-.2.39-.41.62-.64l5.65-5.65c1.82-1.8 2.44-2.23 4.68 0l3.51 3.52c.54.53.9.98 1.12 1.37 0 .007.003.01.01.01.42.73-.26 1.6-1.08 1.44h-.01z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 16c-.74 0-1.07.4-1.44.87-.8.99-1.16 2.07-1.03 3.11.15 1.19 1.17 2.02 2.47 2.02 1.3 0 2.32-.83 2.47-2.03.13-1.04-.22-2.11-1.02-3.1-.38-.47-.71-.87-1.45-.87z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldPaintbucket);
export default __webpack_public_path__ + "static/media/vuesax-bold-paintbucket.5218e3581e09185c75a5808da765b00b.svg";
export { ForwardRef as ReactComponent };